module.exports = __webpack_public_path__ + "img/app-engine-kill.3cdd8d47.svg";